/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import generateResourceTextNarrative from "../compositionResourceFunctions/generateResourceTextNarrative";
import { emptyReasonCodeableConceptSet, sectionCodeCodeableConceptSet } from "../../dictionaries/CodeSystemLookup";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import { TextField } from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import CodeableConceptEntry from "../../datatypeComponents/CodeableConceptEntry";
import SectionEntryArrayEntry from "./SectionEntryArrayEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import { Button } from "semantic-ui-react";
import EditSectionArrayModal from "./EditSectionArrayModal";
import NarrativeEntry from "../../datatypeComponents/NarrativeEntry";
import { selectTriggerRefresh } from "../../slices/triggerRefresh/triggerRefreshSlice";
import { selectTopSectionById, topSectionUpdated } from "../../slices/topSections/topSectionsSlice";
import adjustEmptyReason from "../compositionResourceFunctions/adjustEmptyReason";

const adjustEmptyReasonInLocation = (newTopSectionDetail, autoChangedEmptyReasonChanged,
    dispatch, resourceChanges, compositionId, sectionPath
) => {
    let sectionPathString = "";
    let previousInitialValue = null;
    let previousFinalValue = null;
    switch (sectionPath.length) {
        case 0:
            alert("UNEXPECTED SectionDisplay call for emptyReason editing: sectionPath length = 0");
            break;
        case 1:
            alert("UNEXPECTED SectionDisplay call for emptyReason editing: sectionPath length = 1");
            previousInitialValue = newTopSectionDetail.initialSection.emptyReason;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection.emptyReason) {
                delete newTopSectionDetail.revisedSection.emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "]";
            break;
        case 2:
            previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.emptyReason || null;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.section[sectionPath[1]].emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection?.section[sectionPath[1]].emptyReason) {
                delete newTopSectionDetail.revisedSection.section[sectionPath[1]].emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
            break;
        case 3:
            previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.emptyReason || null;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].emptyReason) {
                delete newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
            break;
        case 4:
            previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.emptyReason || null;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].emptyReason) {
                delete newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
            break;
        case 5:
            previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.emptyReason || null;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].emptyReason) {
                delete newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
            break;
        case 6:
            previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.emptyReason || null;
            previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].emptyReason);
            if (autoChangedEmptyReasonChanged) {
                newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].emptyReason = autoChangedEmptyReasonChanged;
            } else if (newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].emptyReason) {
                delete newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].emptyReason;
            }
            sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
            break;
        default:
            alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for emptyReason editing with sectionPath " + sectionPath.toString());
    }
    if (autoChangedEmptyReasonChanged !== undefined &&
        previousFinalValue !== JSON.stringify(autoChangedEmptyReasonChanged) &&
        !(!previousFinalValue && !autoChangedEmptyReasonChanged)) {
        console.log("resourceUpdate for Composition." + sectionPathString + ".emptyReason");
        updateChangeReport(dispatch, resourceChanges, compositionId,
            "CodeableConcept",
            sectionPathString + ".emptyReason",
            previousInitialValue,
            autoChangedEmptyReasonChanged);
    } else {
        autoChangedEmptyReasonChanged = "no change";
    }
    return autoChangedEmptyReasonChanged;
};

const SectionDisplay = ({ sectionPath, foi, resourceReferenceMap, setParentSectionState }) => {
    const topSection = useSelector(state => selectTopSectionById(state, sectionPath[0]));
    const compositionId = topSection?.compositionId;
    const compositionType = topSection?.productFamily || "Composition";
    const compositionTitle = resourceReferenceMap?.compositionTitle;
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const triggerRefresh = useSelector(selectTriggerRefresh);
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceCollection = useSelector(state => selectAllResources(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));

    const [sectionLoaded, setSectionLoaded] = useState({});
    const [expandState, setExpandState] = useState(false);
    const [editSectionModal, setEditSectionModal] = useState({ "openModal": false });
    const [sectionState, setSectionState] = useState({});

    useEffect(() => {
        if (!sectionLoaded.compositionTitle && topSection?.revisedSection) {
            let topSectionJson = topSection.revisedSection;
            let sectionPathString;
            let section;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for sectionPath length = 1");
                    section = topSectionJson;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    section = topSectionJson.section[sectionPath[1]];
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    section = topSectionJson.section[sectionPath[1]].section[sectionPath[2]];
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    section = topSectionJson.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]];
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    section = topSectionJson.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]];
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    section = topSectionJson.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]];
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for title editing with sectionPath " + sectionPath.toString());
            }
            let sectionCode = section?.code?.coding?.[0]?.code || section?.code?.text;
            let generatedNarrative;
            if (section?.entry?.length === 1 && section.entry[0]?.reference?.split("/").length === 2 &&
                !isNaN(section.entry[0].reference.split("/")[1])) {
                let resourceFoi = section.entry[0].reference.split("/")[1];
                let resourceDictionary = {};
                for (const entry of resourceCollection) {
                    resourceDictionary[entry.id] = entry;
                }
                if (resourceDictionary[resourceFoi] && resourceDictionary[resourceFoi].revisedResourceJson) {
                    let resourceJson = resourceDictionary[resourceFoi].revisedResourceJson;
                    generatedNarrative = generateResourceTextNarrative(resourceJson);
                }
            }
            setSectionLoaded({
                "section": section, "sectionCode": sectionCode,
                "sectionPathString": sectionPathString, "sectionPath": sectionPath,
                "compositionType": compositionType, "compositionTitle": compositionTitle,
                "generatedNarrative": generatedNarrative, "focus": section?.focus
            });
        }
    }, [topSection, sectionLoaded.compositionTitle, sectionPath, triggerRefresh]);

    useEffect(() => {
        if (sectionLoaded.section) {
            let section = sectionLoaded.section;
            setSectionState({
                "editTitle": false,
                "title": section.title || "",
                "code": section.code || null,
                "focus": section.focus || null,
                "text": section.text || {
                    "status": "empty",
                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No Narrative text.]</p></div>'
                },
                "entry": section.entry || [],
                "emptyReason": section.emptyReason || null,
                "section": section?.section || []
            });
        }
    }, [sectionLoaded, triggerRefresh]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for title editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for title editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection?.title;
                    previousFinalValue = newTopSectionDetail.revisedSection.title;
                    newTopSectionDetail.revisedSection.title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.title || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].title;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.title || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].title;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.title || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].title;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.title || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].title;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.title || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].title;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].title = sectionState.title;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for title editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(sectionState.title)) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".title");
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].text = sectionState.text;
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "string",
                    sectionPathString + ".title",
                    previousInitialValue,
                    sectionState.text);
            }
        }
    }, [sectionState.title]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for code editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for code editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection.code;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.code);
                    newTopSectionDetail.revisedSection.code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.code || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].code);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.code || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].code);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.code || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].code);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.code || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].code);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.code || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].code);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].code = sectionState.code;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for code editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.code !== undefined &&
                previousFinalValue !== JSON.stringify(sectionState.code)) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".code");
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].code = sectionState.code;
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "CodeableConcept",
                    sectionPathString + ".code",
                    previousInitialValue,
                    sectionState.code);
            }
        }
    }, [sectionState.code]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for focus editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for focus editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection.focus;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.focus);
                    newTopSectionDetail.revisedSection.focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.focus || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].focus);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.focus || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].focus);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.focus || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].focus);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.focus || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].focus);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.focus || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].focus);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].focus = sectionState.focus;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for focus editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.focus !== undefined &&
                previousFinalValue !== JSON.stringify(sectionState.focus) &&
                !(sectionState.focus === null && previousInitialValue === null)) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".focus");
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].focus = sectionState.focus;
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "Reference",
                    sectionPathString + ".focus",
                    previousInitialValue,
                    sectionState.focus);
            }
        }
    }, [sectionState.focus]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for text editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for text editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection.text;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.text);
                    newTopSectionDetail.revisedSection.text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.text || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].text);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.text || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].text);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.text || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].text);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.text || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].text);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.text || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].text);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].text = sectionState.text;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for text editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.text !== undefined &&
                previousFinalValue !== JSON.stringify(sectionState.text)
                && !(previousFinalValue === JSON.stringify(undefined) &&
                    sectionState.text.status === "empty")) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".text");
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "Narrative",
                    sectionPathString + ".text",
                    previousInitialValue,
                    sectionState.text);
                let autoChangedEmptyReasonChanged = adjustEmptyReason(sectionState, setSectionState);
                if (autoChangedEmptyReasonChanged !== "no change") {
                    autoChangedEmptyReasonChanged = adjustEmptyReasonInLocation(newTopSectionDetail,
                        autoChangedEmptyReasonChanged, dispatch, resourceChanges, compositionId, sectionPath);
                }
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].text = sectionState.text;
                    if (autoChangedEmptyReasonChanged !== "no change") {
                        newSection[sectionPath[sectionPath.length - 1]].emptyReason = autoChangedEmptyReasonChanged;
                    }
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
            }
        }
    }, [sectionState.text]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for entry editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for entry editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection.entry;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.entry);
                    newTopSectionDetail.revisedSection.entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.entry || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].entry);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.entry || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].entry);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.entry || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].entry);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.entry || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].entry);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.entry || null;
                    previousFinalValue = JSON.stringify(newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].entry);
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].entry = sectionState.entry;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for entry editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.entry !== undefined &&
                previousFinalValue !== JSON.stringify(sectionState.entry) &&
                !(!previousInitialValue &&
                    Array.isArray(sectionState.entry) &&
                    (sectionState.entry.length === 0 ||
                        (sectionState.entry.length === 1 && !sectionState.entry[0])
                    )
                )
            ) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".entry");
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "ArrayOfReference",
                    sectionPathString + ".entry",
                    previousInitialValue,
                    sectionState.entry);
                let autoChangedEmptyReasonChanged = adjustEmptyReason(sectionState, setSectionState);
                if (autoChangedEmptyReasonChanged !== "no change") {
                    autoChangedEmptyReasonChanged = adjustEmptyReasonInLocation(newTopSectionDetail,
                        autoChangedEmptyReasonChanged, dispatch, resourceChanges, compositionId, sectionPath);
                }
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].entry = sectionState.entry;
                    if (autoChangedEmptyReasonChanged !== "no change") {
                        newSection[sectionPath[sectionPath.length - 1]].emptyReason = autoChangedEmptyReasonChanged;
                    }
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
            }
        }
    }, [sectionState.entry]);

    useEffect(() => {
        if (editMode && sectionLoaded.section && compositionId) {
            let newTopSectionDetail = JSON.parse(JSON.stringify(topSection));
            let sectionPathString = "";
            let previousInitialValue = null;
            let previousFinalValue = null;
            switch (sectionPath.length) {
                case 0:
                    alert("UNEXPECTED SectionDisplay call for section editing: sectionPath length = 0");
                    break;
                case 1:
                    alert("UNEXPECTED SectionDisplay call for section editing: sectionPath length = 1");
                    previousInitialValue = newTopSectionDetail.initialSection.section;
                    previousFinalValue = newTopSectionDetail.revisedSection.section;
                    newTopSectionDetail.revisedSection.section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "]";
                    break;
                case 2:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "]";
                    break;
                case 3:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "]";
                    break;
                case 4:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "]";
                    break;
                case 5:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "]";
                    break;
                case 6:
                    previousInitialValue = newTopSectionDetail.initialSection?.section[sectionPath[1]]?.section[sectionPath[2]]?.section[sectionPath[3]]?.section[sectionPath[4]]?.section[sectionPath[5]]?.section || null;
                    previousFinalValue = newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].section;
                    newTopSectionDetail.revisedSection.section[sectionPath[1]].section[sectionPath[2]].section[sectionPath[3]].section[sectionPath[4]].section[sectionPath[5]].section = sectionState.section;
                    sectionPathString = "section[" + sectionPath[0] + "].section[" + sectionPath[1] + "].section[" + sectionPath[2] + "].section[" + sectionPath[3] + "].section[" + sectionPath[4] + "].section[" + sectionPath[5] + "]";
                    break;
                default:
                    alert("TOO DEEP SECTION STRUCTURE SectionDisplay call for section editing with sectionPath " + sectionPath.toString());
            }
            if (sectionState.section !== undefined &&
                JSON.stringify(previousFinalValue &&
                    previousFinalValue.map(section => section.code))
                !== JSON.stringify(sectionState.section.map(section => section.code)) &&
                !(!previousInitialValue &&
                    Array.isArray(sectionState.section) &&
                    (sectionState.section.length === 0 ||
                        (sectionState.section.length === 1 && !sectionState.section[0])
                    )
                )
            ) {
                console.log("resourceUpdate for Composition." + sectionPathString + ".section");
                updateChangeReport(dispatch, resourceChanges, compositionId,
                    "ArrayOfSection",
                    sectionPathString + ".section",
                    previousInitialValue,
                    sectionState.section);
                let autoChangedEmptyReasonChanged = adjustEmptyReason(sectionState, setSectionState);
                if (autoChangedEmptyReasonChanged !== "no change") {
                    autoChangedEmptyReasonChanged = adjustEmptyReasonInLocation(newTopSectionDetail,
                        autoChangedEmptyReasonChanged, dispatch, resourceChanges, compositionId, sectionPath);
                }
                dispatch(topSectionUpdated(newTopSectionDetail));
                setParentSectionState(prevState => {
                    let newSection = JSON.parse(JSON.stringify(prevState.section));
                    newSection[sectionPath[sectionPath.length - 1]].section = sectionState.section;
                    if (autoChangedEmptyReasonChanged !== "no change") {
                        newSection[sectionPath[sectionPath.length - 1]].emptyReason = autoChangedEmptyReasonChanged;
                    }
                    return {
                        ...prevState,
                        section: newSection
                    }
                });
            }
        }
    }, [sectionState.section]);

    return <>
        {(sectionLoaded.section &&
            (sectionState.title || sectionState.text || sectionState.entry || sectionState.section || sectionState.emptyReason)
        ) &&
            <div id={sectionLoaded.sectionCode}>
                <div>
                    {editMode ?
                        <>
                            {
                                sectionState.editTitle ?
                                    <>
                                        <TextField style={{ width: "100%" }} className="inputField"
                                            type='text' variant='outlined'
                                            placeholder='Enter section title.' value={sectionState.title}
                                            onKeyUp={(event) => {
                                                if (event.key === 'Enter') {
                                                    setSectionState(prevState => {
                                                        return {
                                                            ...prevState,
                                                            "editTitle": false
                                                        }
                                                    });
                                                }
                                            }}
                                            onChange={(e) => {
                                                setSectionState(prevState => {
                                                    return {
                                                        ...prevState,
                                                        "title": e.target.value || ""
                                                    }
                                                });
                                            }} />
                                        <span className={"unselectable"} style={{ cursor: "pointer", color: "blue" }}
                                            onClick={() => { setExpandState(!expandState); }}
                                        >{expandState ? " ▼ collapse" : " ► expand"}
                                        </span>
                                    </>
                                    :
                                    <h3>
                                        <span>{sectionState.title || sectionLoaded.section.title || "Untitled Section"}</span>
                                        <span>  <button type="button" style={{ marginLeft: "12px" }}
                                            onClick={() => {
                                                setSectionState(prevState => {
                                                    return {
                                                        ...prevState,
                                                        "editTitle": true
                                                    }
                                                });
                                            }} >✎ Edit title</button>
                                        </span>
                                        <span className={"unselectable"} style={{ cursor: "pointer", color: "blue" }}
                                            onClick={() => { setExpandState(!expandState); }}
                                        >{expandState ? " ▼ collapse" : " ► expand"}
                                        </span>
                                    </h3>
                            }
                        </>
                        :
                        <h3>
                            {sectionState.title || sectionLoaded.section.title || "Untitled Section"}
                            <span className={"unselectable"} style={{ cursor: "pointer", color: "blue" }}
                                onClick={() => { setExpandState(!expandState); }}
                            >{expandState ? " ▼ collapse" : " ► expand"}
                            </span>
                        </h3>
                    }
                    {expandState && <div style={{ marginLeft: "24px" }}>
                        <div>
                            {editMode ?
                                <NarrativeEntry elementName="text"
                                    startingValue={sectionState.text}
                                    generatedNarrative={sectionLoaded.generatedNarrative}
                                    setResourceState={setSectionState} />
                                :
                                <>{(sectionLoaded.section.text?.div &&
                                    sectionLoaded.section.text.status !== "empty") &&
                                    <>
                                        <ReactMarkdown children={sectionState?.text?.div || sectionLoaded.section.text.div}
                                            rehypePlugins={[rehypeRaw]} />
                                        <br />
                                    </>}
                                </>
                            }
                        </div>
                        {editMode &&
                            <CodeableConceptEntry elementName="code" fieldLabel="Section Code"
                                startingValue={sectionState.code}
                                codeableConceptLevelValueSet={sectionCodeCodeableConceptSet}
                                setResourceState={setSectionState} startCollapsed />
                        }
                        {
                            editMode ?
                                <>
                                    <ReferenceEntry elementName="focus" fieldLabel="Section Focus"
                                        startingValue={sectionState.focus}
                                        setResourceState={setSectionState} deletable startCollapsed />
                                </>
                                :
                                <>
                                    {sectionLoaded.section.focus && <div>
                                        <div>
                                            <b>Section focus: </b>
                                            <DisplayFromFHIRReference reference={sectionState?.focus || sectionLoaded.section.focus} />
                                        </div>
                                        <p></p>
                                    </div>}
                                </>
                        }
                        {(sectionLoaded.section.entry?.length > 0 || sectionLoaded.section.section?.length > 0 || editMode) &&
                            <>
                                <p></p>
                                <p><b>This section contains:</b></p>
                            </>
                        }
                        <div style={{ marginLeft: "24px" }}>
                            {editMode ?
                                <SectionEntryArrayEntry sectionState={sectionState}
                                    setSectionState={setSectionState} sectionLoaded={sectionLoaded}
                                    foi={foi} revisedResourceJson={parentResourceDetail?.revisedResourceJson}
                                    resourceReferenceMap={resourceReferenceMap} />
                                :
                                <>
                                    {(sectionLoaded.section.entry?.length > 0) &&
                                        <>
                                            {sectionLoaded.section.entry.map((entry, entryIndex) => {
                                                return <span key={entryIndex}>
                                                    <p>
                                                        <DisplayFromFHIRReference reference={entry} />
                                                    </p>
                                                </span>
                                            })}
                                        </>}
                                </>
                            }
                            {editMode && <div>
                                <Button className="formButton" style={{ margin: "0px" }}
                                    content="Add/Delete/Reorganize Sections" compact
                                    onClick={() => { setEditSectionModal({ "openModal": true }) }} />
                                <br />
                            </div>}
                            {editSectionModal.openModal &&
                                <EditSectionArrayModal editSectionModal={editSectionModal}
                                    setEditSectionModal={setEditSectionModal}
                                    sectionState={sectionState}
                                    setSectionState={setSectionState} />}
                            {(sectionLoaded.section.section?.length > 0) &&
                                sectionLoaded.section.section.map((subsection, subsectionIndex) => {
                                    return <div key={subsectionIndex}>
                                        <SectionDisplay sectionPath={sectionPath.concat([subsectionIndex])}
                                            foi={foi} setParentSectionState={setSectionState} />
                                    </div>
                                })}
                            {editMode ?
                                <>
                                    <CodeableConceptEntry elementName="emptyReason" fieldLabel="Empty Reason"
                                        startingValue={sectionState.emptyReason}
                                        codeableConceptLevelValueSet={emptyReasonCodeableConceptSet}
                                        setResourceState={setSectionState} deletable startCollapsed />
                                </>
                                :
                                <>
                                    {sectionLoaded.section.emptyReason && <div>
                                        <p>Section is empty: {sectionState?.emptyReason ?
                                            <>{sectionState.emptyReason.coding?.[0]?.display} {sectionState.emptyReason.text}</>
                                            :
                                            <>{sectionLoaded.section.emptyReason.coding?.[0]?.display} {sectionLoaded.section.emptyReason.text}</>}
                                        </p>
                                    </div>}
                                </>
                            }
                        </div>
                        <br />
                    </div>}
                </div>
            </div>}
    </>
}

export default SectionDisplay;